export const IMAGE_TYPES = ["image/jpeg", "image/png", "image/webp"];
export const IMAGE_VALIDATION_ERROR =
  "Please select an image file (JPEG, PNG, or WebP).";

export const validateImageFile = (file, setErrorState) => {
  if (!file) return false;
  if (!IMAGE_TYPES.includes(file.type)) {
    setErrorState?.({ error: true, message: IMAGE_VALIDATION_ERROR });
    return false;
  }
  return true;
};
